import { useEffect, useState } from 'react';

const QUERY = '(min-width: 1024px)';

const useIsDesktop = (): boolean => {
	const [isDesktop, setIsDesktop] = useState<boolean>(
		() => typeof window !== 'undefined' && window.matchMedia(QUERY).matches,
	);

	useEffect(() => {
		const media = window.matchMedia(QUERY);
		const onChange = (event: MediaQueryListEvent) =>
			setIsDesktop(event.matches);
		media.addEventListener('change', onChange);
		return () => media.removeEventListener('change', onChange);
	}, []);

	return isDesktop;
};

export default useIsDesktop;
